// Lectura del challenge de Hydra en las páginas del dance OAuth (fase 6b).
// El router corre en HASH mode y Hydra arma URLs RFC-compliant: el
// ?login_challenge=... queda ANTES del '#' (http://localhost/?login_challenge
// =x#/mcp/authorize), así que $route.query llega vacío y el valor real vive
// en window.location.search. Se prueba primero el route por si algún día la
// app migra a history mode.
export const readOauthChallenge = (route, name) =>
	(route.query && route.query[name]) ||
	new URLSearchParams(window.location.search).get(name) ||
	"";
